import React, { FC }           from 'react';
import { History }             from 'history';
import {
  Grid,
  Container,
}                              from '@material-ui/core';
import {
  createStyles,
  makeStyles,
}                              from '@material-ui/core/styles';
import { IOption }             from '@typings/components';
import { IDashLocationState }  from '@typings/dashboard';
import { Dropdown }            from '@components/Dropdown/Dropdown';
import { StatisticsContainer } from '@modules/dashboard/containers/StatisticsContainer';

const useStyles = makeStyles(({ spacing }) => createStyles({
  container       : { paddingBlock: `${spacing(5)}px` },
  dropdownWrapper : {
    display        : 'flex',
    justifyContent : 'flex-end',
  },
}));

interface IDashboardPage extends Pick<History, 'push'>, IDashLocationState {
  accountsOptions : IOption[];
  onCuidChange    : (cuidOption: IOption) => void;
}

export const DashboardPage: FC<IDashboardPage> = ({
  cuid,
  cuName,
  accountsOptions,
  onCuidChange,
  push,
}) => {
  const { container, dropdownWrapper } = useStyles();

  return (
    <Container classes={{ root: container }}>
      <Grid
        spacing    = {5}
        justify    = "center"
        alignItems = "center"
        container
      >
        <Grid item xs={12} classes={{ root: dropdownWrapper }}>
          <Dropdown
            width               = {300}
            field               = {{ value: cuid }}
            options             = {accountsOptions}
            placeholder         = "Select Credit Union"
            customOnValueChange = {onCuidChange}
          />
        </Grid>

        <StatisticsContainer
          cuid   = {cuid}
          cuName = {cuName}
          push   = {push}
        />
      </Grid>
    </Container>
  );
};
